<div class="row" >
</div>


<div class="row group1" >
  <div class="row" style="margin: 1px;">
    <h2 class="content-block"><i class="fa-solid fa-tag icons"></i> Özelleştirilmiş İndirim Oranı</h2>
    <div class="col-md-4 responsive-paddings">
      <span>Marka :</span>
      <dx-select-box displayExpr="field" valueExpr="id" placeholder="Seçiniz" [dataSource]="brands" [(value)]="selectedBrandId"
      [inputAttr]="{ 'aria-label': 'Series Type' }" [searchExpr]="searchExprOption"
      [searchTimeout]="searchTimeoutOption" [minSearchLength]="minSearchLengthOption" [searchEnabled]="true"
      [showDataBeforeSearch]="showDataBeforeSearchOption" (onValueChanged)="onBrandsChanged($event)">
    </dx-select-box>
  </div>
  <div class="col-md-4 responsive-paddings">
      <span>Model :</span>
      <dx-select-box displayExpr="field" valueExpr="id" placeholder="Seçiniz" [dataSource]="models" [(value)]="selectedModelId" 
      [inputAttr]="{ 'aria-label': 'Series Type' }" [searchExpr]="searchExprOption"
      [searchTimeout]="searchTimeoutOption" [minSearchLength]="minSearchLengthOption" [searchEnabled]="true"
      [showDataBeforeSearch]="showDataBeforeSearchOption"> </dx-select-box>
    </div>
    <div class="col-md-2  responsive-paddings">
      <dx-button icon="save" type="success" text="Kaydet" class="margin" style="top: 30px;"(onClick)="saveSpecificModel()"></dx-button>
    </div>
  </div>

  
  <div class="col-md-12">
    <dx-data-grid [dataSource]="specificDataSource" class=" responsive-paddings" keyExpr="id"
    (onRowUpdating)="update($event)" (onRowRemoved)="delete($event)">
    <dxo-editing mode="popup" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="false">
    </dxo-editing>
    <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="75">
        <dxi-button name="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" hint="Sil"></dxi-button>
      </dxi-column>
      
      <dxi-column dataField="brandId" caption="Marka" [allowEditing]="false">
        <dxo-lookup [dataSource]="brands" valueExpr="id" displayExpr="field" showClearButton="false">
        </dxo-lookup>
        <dxi-validation-rule type="required" message="Model seçmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="modelId" caption="Model" [allowEditing]="false">
        <dxo-lookup [dataSource]="modelsLookup" valueExpr="id" displayExpr="field" showClearButton="false">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="minYear" caption="Min Yıl" [allowEditing]="true">
      </dxi-column>
      <dxi-column dataField="maxYear" caption="Max Yıl" [allowEditing]="true">
      </dxi-column>
      <dxi-column dataField="minKm" caption="Min Km" [allowEditing]="true" cellTemplate="rowNumberFormatterTemplate">
      </dxi-column>
      <dxi-column dataField="maxKm" caption="Max Km" [allowEditing]="true" cellTemplate="rowNumberFormatterTemplate">
      </dxi-column>
      <dxi-column dataField="minTramer" caption="Min Tramer" [allowEditing]="true"
      cellTemplate="rowNumberFormatterTemplate">
    </dxi-column>
      <dxi-column dataField="maxTramer" caption="Max Tramer" [allowEditing]="true"
      cellTemplate="rowNumberFormatterTemplate">
    </dxi-column>
      <dxi-column dataField="cityId" caption="Şehir">
        <dxo-lookup [dataSource]="cities" valueExpr="id" displayExpr="field" showClearButton="false">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="percentageValue" caption="Oran">
        <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isActive" caption="Aktif mi?" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="isDefault" caption="Varsayılan Oran" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="isDefaultYear" caption="Yıl" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="isDefaultKm" caption="Km" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="isDefaultTramar" caption="Tramer" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="isDefaultCity" caption="Şehir" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <div *dxTemplate="let row of 'rowNumberFormatterTemplate'" class="name-template">
        <div>
          {{ getNumberFormatter(row.value) }}
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-road icons"></i> Kilometre Bazlı İndirim Oranları</h2>
    <dx-data-grid [dataSource]="kmDataSource" class="responsive-paddings" keyExpr="id" (onRowUpdating)="update($event)"
    (onRowInserting)="create($event)" (onRowRemoved)="delete($event)"
    (onInitNewRow)="onInitNewRow($event, percentageDataType.Km)">
      <!-- content-block card -->
      <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="75">
        <dxi-button name="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" hint="Sil"></dxi-button>
      </dxi-column>

      <dxi-column dataField="minKm" caption="Min Km" [allowEditing]="true" cellTemplate="rowNumberFormatterTemplate">
        <dxi-validation-rule type="required" message="Km girmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="maxKm" caption="Max Km" [allowEditing]="true" cellTemplate="rowNumberFormatterTemplate">
        <dxi-validation-rule type="required" message="Km girmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="percentageValue" caption="Oran">
        <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isActive" caption="Aktif mi?" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <div *dxTemplate="let row of 'rowNumberFormatterTemplate'" class="name-template">
        <div>
          {{ getNumberFormatter(row.value) }}
        </div>
      </div>
    </dx-data-grid>
  </div>
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-car-burst icons"></i>Tramer Bazlı İndirim Oranları</h2>
    <dx-data-grid [dataSource]="tramerDataSource" class=" responsive-paddings" keyExpr="id"
    (onRowUpdating)="update($event)" (onRowInserting)="create($event)" (onRowRemoved)="delete($event)"
    (onInitNewRow)="onInitNewRow($event, percentageDataType.Tramer)">
    <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
    </dxo-editing>
    <dxo-export [enabled]="false"></dxo-export>
    <dxi-column type="buttons" width="75">
      <dxi-button name="edit" hint="Düzenle"></dxi-button>
      <dxi-button name="delete" hint="Sil"></dxi-button>
      </dxi-column>
      
      <dxi-column dataField="minTramer" caption="Min Tramer" [allowEditing]="true"
      cellTemplate="rowNumberFormatterTemplate">
      <dxi-validation-rule type="required" message="Tramer girmek zorunludur"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="maxTramer" caption="Max Tramer" [allowEditing]="true"
        cellTemplate="rowNumberFormatterTemplate">
        <dxi-validation-rule type="required" message="Tramer girmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="percentageValue" caption="Oran">
        <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isActive" caption="Aktif mi?" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <div *dxTemplate="let row of 'rowNumberFormatterTemplate'" class="name-template">
        <div>
          {{ getNumberFormatter(row.value) }}
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>
<div class="row">
  <div class="col-md-6" style="border-bottom:1px dotted #e2e3e5">
    <h2 class="content-block"><i class="fa-solid fa-city icons"></i> Şehir Bazlı İndirim Oranları</h2>
    <dx-data-grid [dataSource]="cityDataSource" class=" responsive-paddings" keyExpr="id"
      (onRowUpdating)="update($event)" (onRowInserting)="create($event)" (onRowRemoved)="delete($event)"
      (onInitNewRow)="onInitNewRow($event, percentageDataType.City)">
      <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="75">
        <dxi-button name="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" hint="Sil"></dxi-button>
      </dxi-column>

      <dxi-column dataField="cityId" caption="Şehir">
        <dxo-lookup [dataSource]="cities" valueExpr="id" displayExpr="field" showClearButton="false">
        </dxo-lookup>
        <dxi-validation-rule type="required" message="Şehir seçmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="percentageValue" caption="Oran">
        <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isActive" caption="Aktif mi?" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  </div>
  <div class="col-md-6" style="border-bottom:1px dotted #e2e3e5">
    <h2 class="content-block"><i class="fa-solid fa-calendar-days icons"></i>Yıl Bazlı İndirim Oranları</h2>
    <dx-data-grid [dataSource]="yearDataSource" class=" responsive-paddings" keyExpr="id"
    (onRowUpdating)="update($event)" (onRowInserting)="create($event)" (onRowRemoved)="delete($event)"
    (onInitNewRow)="onInitNewRow($event, percentageDataType.Year)">
      <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="75">
        <dxi-button name="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" hint="Sil"></dxi-button>
      </dxi-column>

      <dxi-column dataField="minYear" caption="Min Yıl" [allowEditing]="true">
        <dxi-validation-rule type="required" message="Yıl girmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="maxYear" caption="Max Yıl" [allowEditing]="true">
        <dxi-validation-rule type="required" message="Yıl girmek zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="percentageValue" caption="Oran">
        <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isActive" caption="Aktif mi?" dataType="boolean">
        <dxo-lookup [dataSource]="booleanType" valueExpr="id" displayExpr="name">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  </div>
  <div class="col-md-3">
    <h2 class="content-block "><i class="fa-solid fa-percent icons"></i> Varsayılan İndirim Oranı</h2>
    <dx-data-grid [dataSource]="defaultDataSource" class=" responsive-paddings" keyExpr="id"
    (onRowUpdating)="update($event)">
    <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="false" [allowAdding]="false"
    [allowFiltering]="false" [allowSorting]="false">
  </dxo-editing>
  <dxo-export [enabled]="false"></dxo-export>
  <dxi-column type="buttons" width="75">
    <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
  </dxi-column>
  
  <dxi-column dataField="percentageValue" caption="Oran">
    <dxi-validation-rule type="required" message="Oran zorunludur"></dxi-validation-rule>
  </dxi-column>
  <dxo-export [enabled]="false"></dxo-export>
  </dx-data-grid>
  </div>
  <div class="col-md-9">
  <h2 class="content-block "><i class="fa fa-info icons"></i> Kullanım Kılavuzu</h2> 
  <div class=" responsive-paddings info-general ">
  <ol>
    <li><strong>Varsayılan İndirim Oranı:</strong>Varsayılan indirim oranı tüm araçlar için geçerli olan genel bir orandır.</li> <br>
    <li><strong>Özelleştirilmiş İndirim Oranı:</strong> Özelleştirilmiş indirim oranı, belirlenen <b>MARKA</b> ve <B>MODEL'</B>e ait tanımlanan indirim oranıdır. Bu indirim oranı, marka ve model seçilerek kaydedilir. Kaydedilen marka ve modeller tabloda listelenir. Her bir kayıt satırında <b>düzenle</b> ve <b>sil</b> butonları bulunur. Düzenlenmek istenen kayıt seçilir ve <b>YIL, KM,TRAMER,ŞEHİR</b> gibi indirim kalem limitleri eklenir. <b>ORAN</b> alanına tanımlanacak olan indirim oranı yazılır. Bu indirim oranının <b>AKTİF </b> olup olmadığını düzenle formundan belirlenir. Aktif ise kutucuk işaretlenir ve bu kayıt için geçerli indirim oranı belirlenir.
     Düzenleme formunda yer alan <b>VARSAYILAN ORAN </b> , <b>EVET</b> seçili ise, <b>Varsayılan İndirim Oranı</b> tablosunda yer alan genel indirim oranı bu kayıt için geçerli olur.
    <b>YIL, KM, TRAMER, ŞEHİR</b> bilgileri bu kayıt için varsayılan <b>HAYIR </b> olarak  seçili gelir. Eğer <b>YIL, KM, TRAMER, ŞEHİR</b> bilgileri bu kayıt için  <b>EVET </b> seçilirse sayfanın alt kısmında yer alan <b>KM, TRAMER, ŞEHİR, YIL</b> tablolarındaki indirim oranları geçerli olur. Web kullanıcısından gelen bilgiye göre sistem otomatik olarak indirim oranını tanımlar. <br>
    <b>Örnek olarak:</b> Özelleştirilmiş bir kayıt yapalım. <b>HONDA / CİVİC</b> marka bir araç için <b>YIL, KM, TRAMER</b> bilgisi girilmiş fakat şehir bilgisi girilmemiş olsun. Form içerisinde yer alan şehir bilgisi <b>EVET </b> seçilirse şehir indirimleri tablosundan indirim oranı bu kayıt için geçerli olur.</li>
  </ol>
  </div> 
  </div>
</div>